module.exports = __webpack_public_path__ + "img/EndEvent.e5bd8e1c.svg";